// src/utils/ipfsConfig.ts
let _ipfsGatewayUrl = '';
export const setIpfsGatewayUrl = (url: string) => { _ipfsGatewayUrl = url; };
export const getIpfsGatewayUrl = (): string => {
  if (!_ipfsGatewayUrl) console.warn('[IPFS] Gateway URL not yet loaded from tenant record.');
  return _ipfsGatewayUrl;
};
